import { useController, useFormContext } from "react-hook-form";
import {
  useFormAttachments,
  useFormFlatItems,
  useFormModel,
} from "../FormDefinitionRenderer/contexts.js";
import ClaimGeneralAttachmentsField from "./FilePicker/ClaimGeneralAttachmentsField.jsx";
import { collectAttachmentSources } from "../../MDDForm/helper.js";

export default function ClaimAttachmentsControl({ item, disabled }) {
  const model = useFormModel();
  const flatItems = useFormFlatItems();
  const attachments = useFormAttachments();
  const { control } = useFormContext();

  const {
    field,
    fieldState: { error },
  } = useController({ name: item.name, control, defaultValue: [] });

  const attachmentSources = collectAttachmentSources(flatItems, item.name).map(
    (source) => ({ ...source, value: undefined })
  );

  return (
    <ClaimGeneralAttachmentsField
      name={item.name}
      label={item.label}
      multiple={item.multiple !== false}
      claimId={model?.id}
      claimAttachmentFiles={attachments?.claimAttachmentFiles ?? []}
      costs={[]}
      attachmentSources={attachmentSources}
      addDescription={item.add_description}
      trackAsSource={Boolean(item.track_as_source)}
      showOtherFieldFiles={item.show_other_field_files}
      preventSelectingOtherFieldFiles={item.prevent_selecting_other_field_files}
      value={field.value ?? []}
      onChange={field.onChange}
      onBlur={field.onBlur}
      disabled={disabled}
      error={!!error}
      helperText={error?.message ?? item.helperText}
      sessionAttachmentFiles={attachments?.sessionAttachmentFiles ?? []}
      addSessionAttachmentFile={attachments?.addSessionAttachmentFile}
      updateSessionAttachmentFileDescription={
        attachments?.updateSessionAttachmentFileDescription
      }
    />
  );
}
